module.exports = __webpack_public_path__ + "static/media/link-icon.8c3550ed.svg";